module.exports = __webpack_public_path__ + "img/custom-13.d9aa3565.svg";